import React, { useEffect } from 'react';
import { Modal as AntdModal } from 'antd';
export interface ModalProps {
  open?: boolean;
  title?: React.ReactNode;
  closable?: boolean;
  onCancel?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  width?: string | number;
  footer?: React.ReactNode;
  destroyOnClose?: boolean;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  wrapClassName?: string | undefined;
  getContainer?: any;
}

export const Modal = ({
  open,
  children,
  footer,
  title,
  width,
  destroyOnClose,
  closable = true,
  onCancel,
  style,
  className,
  getContainer = document.getElementById('app-root')!,
  wrapClassName,
}: ModalProps) => {

  // disable background scrolling when modal open
  useEffect(() => {
    const scrollY = window.scrollY;
    if (open) {
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.overflow = 'hidden';
    }
    else {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';
      window.scrollTo(0, scrollY);
    }

    return () => {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';
      window.scrollTo(0, scrollY);
    };
  }, [open]);

  return (
    <AntdModal
      className={className}
      open={open}
      footer={footer}
      title={title}
      width={width}
      destroyOnClose={destroyOnClose}
      getContainer={getContainer}
      closable={closable}
      onCancel={onCancel}
      style={style}
      wrapClassName={wrapClassName}
    >
      {children}
    </AntdModal>
  );
};
